module.exports = (props) => [
	{
		titleText: 'Manage Field Programs',
		key: 'FieldAdmin',
		children: [
			{label: 'View Programs', visible: true},
			{label: 'New Program', visible: false},
			{label: 'Edit Program', visible: false},
			{label: 'Delete Program', visible: false}
		]
	}
];



// WEBPACK FOOTER //
// ./src/containers/Portal/adminMenuItems.js